import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import HorizontalStepperWithError from './HorizontalStepperWithError';
import ClientProvider from './client';
export default createDemo(import.meta.url, HorizontalStepperWithError, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/steppers/demos/horizontal-with-error/HorizontalStepperWithError.tsx",
    "fileName": "HorizontalStepperWithError.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Stepper from '@mui/material/Stepper';\nimport Step from '@mui/material/Step';\nimport StepLabel from '@mui/material/StepLabel';\nimport Typography from '@mui/material/Typography';\n\nconst steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];\n\nexport default function HorizontalStepperWithError() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const isStepFailed = (step: number) => {\n    return step === 1;\n  };\n\n  return (\n    <Box sx={{ width: '100%' }}>\n      <Stepper activeStep={1}>\n        {steps.map((label, index) => {\n          const labelProps: {\n            optional?: React.ReactNode;\n            error?: boolean;\n          } = {};\n          if (isStepFailed(index)) {\n            labelProps.optional = (\n              <Typography variant=\"caption\" color=\"error\">\n                Alert message\n              </Typography>\n            );\n            labelProps.error = true;\n          }\n\n          return (\n            <Step key={label}>\n              <StepLabel {...labelProps}>{label}</StepLabel>\n            </Step>\n          );\n        })}\n      </Stepper>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 41,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Stepper from '@mui/material/Stepper';\nimport Step from '@mui/material/Step';\nimport StepLabel from '@mui/material/StepLabel';\nimport Typography from '@mui/material/Typography';\n\nconst steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];\n\nexport default function HorizontalStepperWithError() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const isStepFailed = (step: number) => {\n    return step === 1;\n  };\n\n  return (\n    <Box sx={{ width: '100%' }}>\n      <Stepper activeStep={1}>\n        {steps.map((label, index) => {\n          const labelProps: {\n            optional?: React.ReactNode;\n            error?: boolean;\n          } = {};\n          if (isStepFailed(index)) {\n            labelProps.optional = (\n              <Typography variant=\"caption\" color=\"error\">\n                Alert message\n              </Typography>\n            );\n            labelProps.error = true;\n          }\n\n          return (\n            <Step key={label}>\n              <StepLabel {...labelProps}>{label}</StepLabel>\n            </Step>\n          );\n        })}\n      </Stepper>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 41,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Stepper",
      "@mui/material/Step",
      "@mui/material/StepLabel",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
